export const SignatureType = {
  BankID: 'BANKID',
  Draw: 'DRAW',
  Click: 'CLICK'
};
